
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.44 22.403c-.748-5.27-5.155-9.458-10.716-10.185l-.486-.064V6h-2.476v6.154l-.486.064c-5.56.727-9.968 4.915-10.717 10.185l-.065.463H5v2.345h6.5l.068.458c.778 5.232 5.184 9.39 10.708 10.113l.486.064V42h2.476v-6.154l.486-.064c5.524-.722 9.927-4.88 10.708-10.113l.067-.458H43v-2.345h-6.492l-.065-.463h-.002zM24 33.77c-5.685 0-10.31-4.382-10.31-9.768 0-5.385 4.625-9.767 10.31-9.767 5.684 0 10.31 4.382 10.31 9.767 0 5.386-4.625 9.768-10.31 9.768z","fill":"#88C0B3"}})])
          )
        }
      }
    